const Links = () => {
  return (
    // <section className="bg-gray-100 px-6 md:px-16 py-12">
    //   <div className="max-w-7xl mx-auto">
    //     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
    //       {/* LEFT - BRAND */}
    //       <div>
    //         <h2 className="text-2xl font-bold">
    //           <span className="text-yellow-500">Nex</span>Testify
    //         </h2>

    //         <p className="mt-4 text-gray-600 leading-relaxed">
    //          <span className="text-yellow-500">NextTestify empowers</span>  educators and organizations with smart
    //           assessment tools, AI-driven question creation, and seamless exam
    //           management.
    //         </p>

    //         {/* Social Icons */}
    //         <div className="flex gap-3 mt-6">
    //           <Link>
    //             <FaFacebookF />
    //           </Link>
    //           <Link>
    //             <FaXTwitter />
    //           </Link>
    //           <Link className="w-10 h-10 flex items-center justify-center border rounded-full text-gray-600 hover:bg-yellow-500 hover:text-white transition">
    //             <FaInstagram />
    //           </Link>
    //           <Link className="w-10 h-10 flex items-center justify-center border rounded-full text-gray-600 hover:bg-yellow-500 hover:text-white transition">
    //             <FaLinkedinIn />
    //           </Link >
    //         </div>
    //       </div>

    //       {/* PRODUCTS */}
    //       <div>
    //         <h5 className="font-semibold text-lg mb-4 border-l-2 border-yellow-500 pl-3">
    //           Products
    //         </h5>
    //         <ul className="space-y-2 text-gray-600">
    //           <li>
    //             <Link
    //               to="/SkillsAndKnowledgeAssessment"
    //               className="hover:text-yellow-500"
    //             >
    //               Assessment
    //             </Link>
    //           </li>
    //           <li>
    //             <Link to="/Nextestify" className="hover:text-yellow-500">
    //               Online Quiz Maker
    //             </Link>
    //           </li>
    //           <li>
    //             <Link to="/Customization" className="hover:text-yellow-500">
    //               Test Maker
    //             </Link>
    //           </li>
    //           <li>
    //             <Link to="/AI" className="hover:text-yellow-500">
    //               AI Question Creation
    //             </Link>
    //           </li>
    //           <li>
    //             <Link to="/Proctoring" className="hover:text-yellow-500">
    //               Proctoring
    //             </Link>
    //           </li>
    //         </ul>
    //       </div>

    //       {/* RESOURCES */}
    //       <div>
    //         <h5 className="font-semibold text-lg mb-4 border-l-2 border-yellow-500 pl-3">
    //           Resources
    //         </h5>
    //         <ul className="space-y-2 text-gray-600">
    //           <li>
    //             <Link to="/about-us" className="hover:text-yellow-500">
    //               About Us
    //             </Link>
    //           </li>
    //           <li>
    //             <Link to="/blogs" className="hover:text-yellow-500">
    //               Blogs
    //             </Link>
    //           </li>
    //           <li>
    //             <Link to="/management" className="hover:text-yellow-500">
    //               Management
    //             </Link>
    //           </li>
    //           <li>
    //             <Link to="/contact-us" className="hover:text-yellow-500">
    //               Contact Us
    //             </Link>
    //           </li>
    //         </ul>
    //       </div>

    //       {/* CONTACT */}
    //       <div>
    //         <h5 className="font-semibold text-lg mb-4 border-l-2 border-yellow-500 pl-3">
    //           Contact Us
    //         </h5>
    //         <ul className="space-y-3 text-gray-600">
    //           <li>
    //             <a
    //               href="mailto:Support@resilink.in"
    //               className="hover:text-yellow-500"
    //             >
    //               Support@resilink.in
    //             </a>
    //           </li>
    //           <li>
    //             <a href="tel:+919566558355" className="hover:text-yellow-500">
    //               +91-9566558355
    //             </a>
    //           </li>
    //         </ul>
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <></>
  );
};

export default Links;
